export const PAGE_KEY = 'time-attendance-admin-hours-calculation';
